import AuthZeroRole from "./AuthZeroRole";

export default class AuthZeroMember {
    constructor(data) {
        this.userId = data.user_id || data.User_Id || data.userId;
        this.name = data.name;
        this.email = data.email;
        this.picture = data.picture;
        this.role = "undefined";

        if (data.roles != null){
            data.roles.forEach(element => {
                this.role = new AuthZeroRole(element);
            });
        }
    }
}
